import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Header } from "@/components";
import { useAppDispatch } from "@/redux/store";
import { fetchFeedback } from "@/redux/feedback/asyncActions";
import { getTokenFromStorage } from "@/utils";
import { openModal } from "react-url-modal";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";
import contactUsImage from "@/assets/img/ContactUs.png";

import styles from "./Feedback.module.scss";

export const Feedback: React.FC<{ title: string }> = ({ title }) => {
  const dispatch = useAppDispatch();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;
  const [messageText, setMessageText] = useState("");
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = () => {
    const token = getTokenFromStorage();
    if (!token) {
      openModal({ name: "login" });
      return;
    }

    if (messageText.trim().length === 0) return;

    dispatch(fetchFeedback({ text: messageText }))
      .unwrap()
      .then(() => {
        setIsSent(true);
        setMessageText("");
      })
      .catch(() => {});
  };

  if (isSent) {
    return (
      <>
        <Header title={title} headerType={isMobile ? "modal" : "page"} returnButton={isMobile} />
        <main>
          <section className="container">
            <div className={styles.successContainer}>
              <img src={contactUsImage} alt="success" className={styles.successImage} />
              <div className={styles.successTitle}>Сообщение отправлено</div>
              <div className={styles.successSubtitle}>
                Наш менеджер скоро с Вами свяжется
              </div>
            </div>
          </section>
        </main>
      </>
    );
  }

  return (
    <>
      <Header title={title} headerType={isMobile ? "modal" : "page"} returnButton={isMobile} />
      <main>
        <section className="container">
          <div className={styles.wrapper}>
            <div className={styles.pageTitle}>{title}</div>

            <div className={styles.fieldWrapper}>
              <label className={styles.label}>Текст сообщения</label>
              <textarea
                className={styles.textarea}
                placeholder="Ваше обращение"
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                rows={5}
              />
            </div>

            <div className={styles.policy}>
              Продолжая, вы подтверждаете, что ознакомлены и согласны с условиями{" "}
              <Link to="/privacy-policy" className={styles.policyLink}>
                политики конфиденциальности
              </Link>{" "}
              и{" "}
              <Link to="/rules" className={styles.policyLink}>
                правилами клуба
              </Link>
              .
            </div>

            <button
              className={`${styles.submitButton} ${
                messageText.trim().length > 0 ? styles.active : styles.disabled
              }`}
              onClick={handleSubmit}
              disabled={messageText.trim().length === 0}
            >
              Отправить
            </button>
          </div>
        </section>
      </main>
    </>
  );
};
